<script>
export default {
  props: {
    amount: {
      required: true
    },
    decimal: {
      required: false,
      type: Number,
      default: 0,
    }
  }
}
</script>
<template>
  <span :style="{ color: amount >= 0 ? '#237804' : '#a8071a'}">{{ currency(amount, decimal) }}</span>
</template>
